import type { AnimationConfig, PreviewTemplate } from '@game-platform/pack-animation';
import type { PreviewPayload } from './AnimationPreview';

export const IFRAME_ORIGIN = import.meta.env.VITE_IFRAME_ORIGIN || 'http://localhost:7474';

/** The preview iframe lives on another origin, so a backend-relative image path must be absolute. */
function absoluteUrl(url: string): string {
  return new URL(url, window.location.origin).toString();
}

interface Input {
  animation: AnimationConfig;
  designSystem: Record<string, unknown> | null;
  template: PreviewTemplate;
  packImageUrl: string | null | undefined;
  /** Real cards of the pack; the preview falls back to its own placeholder when empty. */
  cardImageUrls: string[] | undefined;
  /** '' = a different rarity each cycle. */
  rarity?: string;
}

/** What the preview scene needs, or null until there is a theme and pack artwork to draw. */
export function buildPreviewPayload(input: Input): PreviewPayload | null {
  if (!input.designSystem || !input.packImageUrl) return null;
  return {
    animation: input.animation,
    designSystem: input.designSystem,
    template: input.template,
    packImageUrl: absoluteUrl(input.packImageUrl),
    cardImageUrls: (input.cardImageUrls ?? []).map(absoluteUrl),
    ...(input.rarity ? { rarity: input.rarity } : {}),
  };
}
